import { createSlice } from '@reduxjs/toolkit';
import { SortingEnum } from '../../utils/enums/SortingEnum';
const initialState = {
    cart: {
        addedToCart: false,
        shoppingItems: [],
        addedToList: false,
        vpcItems: [],
        error: ''
    },
    planner: '',
    storeId: '',
    stores: [],
    zipCode: '',
    availability: {},
    ab_tests: [],
    articlesToShow: 15,
    cms: {
        id: '',
        timestamp: '',
        form: []
    },
    form: {
        wall: '',
        storage_type: [],
        selectState: {},
        tagState: {},
        door_type: '',
        size_depth: '',
        size_depth_left: '',
        size_depth_right: '',
        size_height: '',
        size_width: '',
        size_width_left_85: '',
        size_width_right_85: '',
        size_width_left_88: '',
        size_width_right_88: ''
    },
    sorting: SortingEnum.BestFit
};
const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        selectPill(state, action) {
            const { id, value, tags } = action.payload;
            if (state.form[id].includes(value)) {
                // If the item is already selected, remove it.
                const index = state.form[id].indexOf(value);
                state.form[id].splice(index, 1);
                const updatedTags = [...state.form.tagState[id]];
                // Remove tags for the storage need clicked
                tags.forEach(tagToRemove => {
                    const index = updatedTags.findIndex(tag => tag === tagToRemove);
                    if (index !== -1) {
                        updatedTags.splice(index, 1);
                    }
                });
                state.form.tagState[id] = updatedTags;
            }
            else {
                // Add the selected pill to the state
                state.form[id] = [...state.form[id], value];
                // Add new tags
                state.form.tagState[id] = [...(state.form.tagState[id] ?? []), ...tags];
            }
        },
        selectSelect(state, action) {
            const { id, value, selectedIndex } = action.payload;
            state.form.selectState[id] = {
                value,
                selectedIndex
            };
            state.form[id] = value;
        },
        selectRadio(state, action) {
            const { id, value } = action.payload;
            state.form[id] = value;
        },
        setPlanner(state, action) {
            const { planner, cms } = action.payload;
            state.planner = planner;
            state.cms = cms;
        },
        setStoreId(state, action) {
            state.storeId = action.payload;
        },
        setStores(state, action) {
            state.stores = action.payload;
        },
        setZipCode(state, action) {
            state.zipCode = action.payload;
        },
        setAvailability(state, action) {
            state.availability = action.payload;
        },
        increaseArticlesToShow(state, action) {
            state.articlesToShow = state.articlesToShow + action.payload;
        },
        setABTests(state, action) {
            state.ab_tests = action.payload;
        },
        setAddedToCart(state, action) {
            const { addedToCart, shoppingItems, vpc } = action.payload;
            state.cart.addedToCart = addedToCart;
            vpc && state.cart.vpcItems?.push(vpc);
            if (shoppingItems) {
                for (const item of shoppingItems) {
                    const itemIsInCart = state.cart.shoppingItems.find(obj => obj.id === item.id);
                    if (itemIsInCart) {
                        itemIsInCart.quantity += item.quantity;
                    }
                    else {
                        state.cart.shoppingItems.push(item);
                    }
                }
            }
        },
        setCartError(state, action) {
            const { error } = action.payload;
            state.cart.error = error;
        },
        setSorting(state, action) {
            state.sorting = action.payload;
        }
    }
});
export const { selectPill, selectSelect, selectRadio, setPlanner, setStoreId, setStores, setZipCode, setAvailability, increaseArticlesToShow, setABTests, setAddedToCart, setCartError, setSorting } = appSlice.actions;
export const { reducer } = appSlice;
//# sourceMappingURL=index.js.map